// Dictionnaires zxcvbn-ts par langue (language packs). Ajouter une langue = une ligne ici
// (ex. es: () => import("@zxcvbn-ts/language-es")). Le testeur ne contient aucune condition de langue.
export const ZXCVBN_PACKS = {
  en: () => import("@zxcvbn-ts/language-en"),
  fr: () => import("@zxcvbn-ts/language-fr"),
};
